import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'multiline' })
export class MultilinePipe implements PipeTransform {
  transform(text: string): string {
    return text && text.replace(/\n/g, '<br/>');
  }
}
